import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";

/**
 * Stopping keeps everything the client has already done: completed history
 * stays, and workouts already on their calendar stay there. What disappears is
 * the program itself - no further weeks are issued and unclaimed slots go away.
 *
 * A local-state modal, same reasoning as FlexibleSettings: opening/closing it
 * never touches the server, only confirming Stop does.
 */
const FlexibleStop = ({ cycleId, cycleName, athlete, onClose }) => {
  const { t } = useTranslation("coaching-portal");

  useEffect(() => {
    const handleKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div className="wk-modal-overlay open" onClick={onClose}>
      <div
        className="wk-modal flexible-stop-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="wk-modal-header">
          <h2 className="alt">{t("flexible.stop.title")}</h2>
          <button
            type="button"
            className="wk-modal-close"
            data-button-type="tertiary"
            data-icon-only
            onClick={onClose}
            aria-label={t("flexible.manager.cancel")}
          >
            <img src="/img/new-icons/red-cross.svg" alt="" />
          </button>
        </header>

        <div className="wk-modal-body">
          <div>
            <img
              src="/img/new-icons/red-trash.svg"
              alt=""
              className="mx-auto"
            />
          </div>
          <p className="text-center">
            {t("flexible.stop.confirmMessage", { cycleName })}
          </p>
        </div>

        {/* Sibling of .wk-modal-body, same reasoning as FlexibleSettings. */}
        <footer className="wk-modal-footer">
          <button type="button" data-button-type="secondary" onClick={onClose}>
            {t("flexible.manager.cancel")}
          </button>
          <button
            type="button"
            data-button-type="secondary"
            data-action="cancel"
            onClick={() => {
              // The one real network call here: it stops the program, then
              // the action's res.redirect leaves this page entirely, so
              // there is nothing local left to close afterward.
              submit(`/actions/cycle/${cycleId}/flexible-stop`, {
                method: "POST",
                body: { athlete },
              });
            }}
          >
            {t("flexible.stop.action")}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default FlexibleStop;
